const defaultPaginationSetting = {
  pageNum: 1,
  pageSize: 20,
  pageSizes: [20, 50, 100, 200],
  total: 0,
  layout: 'total, sizes, prev, pager, next, jumper'
}

export { defaultPaginationSetting }
